module.exports = __webpack_public_path__ + "static/media/ribbon.ba6b2ff2.svg";